import { temAcesso } from '@/shared/auth/temAcesso'

const SolicitacoesReaberturas = () => import('./SolicitacoesReaberturas.vue')

export default {
    path: 'solicitacoesReaberturas',
    name: 'Gerentes_SolicitacoesReaberturas',
    component: SolicitacoesReaberturas,
    beforeEnter: (to, from, next) => {
        if (temAcesso('CRED-GER-ENTR-02')) {
            next()
        }
    }
}
